import type { DeviceBridge, QueuedJob } from '@enp-suite/bridge';
import { createContext, useContext, useSyncExternalStore, type ReactNode } from 'react';

const BridgeContext = createContext<DeviceBridge | null>(null);

export function BridgeProvider({
  bridge,
  children,
}: {
  bridge: DeviceBridge;
  children: ReactNode;
}) {
  return <BridgeContext.Provider value={bridge}>{children}</BridgeContext.Provider>;
}

export function useBridge(): DeviceBridge {
  const bridge = useContext(BridgeContext);
  if (!bridge) throw new Error('useBridge() needs a <BridgeProvider>');
  return bridge;
}

/** Failed print jobs waiting for a reprint (re-renders when the list changes). */
export function useReprints(): readonly QueuedJob[] {
  const { reprints } = useBridge();
  return useSyncExternalStore(
    (onChange) => reprints.subscribe(onChange),
    () => reprints.list(),
  );
}
